import React from 'react';
import { IconSidebarLeft2OutlineDuo18 } from 'nucleo-ui-outline-duo-18';

import { cn } from '@lyearn/style';
import { sidebarIconStrokeWidth } from '@/modules/corporate/modules/admin/components/Sidebar/nav-icon';
import {
  SIDEBAR_FOCUS_RING,
  SIDEBAR_ROW_REST,
} from '@/modules/corporate/modules/admin/components/Sidebar/theme';

export interface SidebarToggleProps {
  isCollapsed?: boolean;
  onToggle?: () => void;
}

const SidebarToggle = (props: SidebarToggleProps) => {
  const { isCollapsed, onToggle } = props;

  return (
    <button
      aria-label={isCollapsed ? 'Show sidebar' : 'Hide sidebar'}
      aria-pressed={isCollapsed}
      className={cn(
        'flex h-32 w-32 flex-shrink-0 cursor-pointer items-center justify-center rounded-8 transition-colors duration-100 disabled:cursor-default',
        SIDEBAR_ROW_REST,
        SIDEBAR_FOCUS_RING,
      )}
      disabled={!onToggle}
      type="button"
      onClick={onToggle}>
      <IconSidebarLeft2OutlineDuo18
        className="h-20 w-20 [&_[data-color='color-2']]:hidden [&_path:last-child]:fill-current"
        strokeWidth={sidebarIconStrokeWidth(20)}
      />
    </button>
  );
};

export default React.memo(SidebarToggle);
